export default "__VITE_ASSET__CAhYruIQ__"